import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowValueDiscount from 'LuxKit/PricePoints/Value/PriceRowValueDiscount'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'
import type { CruiseOfferPriceVariation } from 'lib/cruises/cruiseUtils'

export interface PriceRoomTypeProps {
  offer?: App.CruiseOffer
  priceFrom: App.CruisePriceDetails
  price: CruiseOfferPriceVariation
  memberPrice?: CruiseOfferPriceVariation
  memberPriceType?: App.Cruises.CruiseMemberPriceType
  header?: boolean
  hasValidDepartures?: boolean
}

function CruisePriceRoomTypeInfo({ priceFrom, price, memberPrice, memberPriceType, hasValidDepartures, header = false }: PriceRoomTypeProps) {
  const intl = useIntl()

  const fromCaption = intl.formatMessage({
    id: 'lZ-S_ZGKEPbpKqabJg9G',
    defaultMessage: 'From',
    description: 'Price caption indicating starting price for cruise offer',
  })

  return (
    <>
      <Group direction="vertical" gap={4}>
        {hasValidDepartures && <div>
          <PriceRowPriceCaption>{fromCaption}</PriceRowPriceCaption>
          <LuxPlusPriceStack
            size="S"
            price={price.primaryPrice.total}
            memberPrice={memberPrice?.primaryPrice.total}
            saleUnit={price.primaryPrice.type}
            mode={memberPriceType === 'STANDARD_PRICE' ? 'member-only' : undefined}
          />
          <PriceRowCaption>
            {intl.formatMessage({
              id: 'F9_v4gAnxcZCq6ZVxwDc',
              defaultMessage: 'Twin share',
              description: 'Cruise price caption stating the twin-share/double-occupancy basis: two passengers sharing one cabin. This is an occupancy/pricing basis and does not specify or promise two separate beds.',
            })}
          </PriceRowCaption>

          {!header && priceFrom.discountPills?.discountPercentage && <PriceRowValueDiscount
            type="estimate"
            discountPercentage={priceFrom.discountPills.discountPercentage}
          />}
        </div>}
      </Group>

      {!hasValidDepartures && <Group direction="vertical" verticalAlign="center" fullWidth>
        <BodyText variant="large" weight="bold" align="center">
          {intl.formatMessage({
            id: 'hZqiWh9QZkxCrRGrIaYZ',
            defaultMessage: 'This offer has sold out',
            description: 'Message displayed when cruise offer has no available departures',
          })}
        </BodyText>
      </Group>}
    </>
  )
}

export default CruisePriceRoomTypeInfo
